import React, { useRef } from "react";
import {
  DialogTitle,
  Dialog,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { CloseIcon } from "@icarius-icons";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import { useDispatch } from "react-redux";
import CommonPage from "@icarius-common/commonPage";
import { getLocalizedString } from "@icarius-localization/strings";

const StyledDialog = withStyles({
  paper: {
    maxHeight: "95%",
    minHeight: "85%",
    maxWidth: "95%",
    minWidth: "85%",
  },
})(Dialog);

const GridSelectionDialog = (props) => {

  const {
    open,
    data,
    preselected,
    handleConfirm,
    handleClose,
  } = props;

  const dispatch = useDispatch();
  const ownGridRef = useRef();

  const onRowDataChanged = () => {
    //preseleccionar
    ownGridRef.current.api.forEachNodeAfterFilter((node) => {
      if (preselected.includes(node.data['CODIGO DE EMPLEADO'])) {
        node.setSelected(true);
      }
    });
  }

  const handleSubmit = () => {
    if (ownGridRef.current) {
      let selectedRows = ownGridRef.current.api.getSelectedRows();

      if (selectedRows.length === 0) {
        dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectAtLeastOneRow"), severity: "warning" }));
        return;
      }

      const collaboratorCodes = selectedRows.map((row) => row["CODIGO DE EMPLEADO"])
      handleConfirm(collaboratorCodes);
      handleClose();
    }
  };

  return (
    <StyledDialog
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      open={open}
      scroll={"paper"}
      fullWidth={true}
      maxWidth={"md"}
    >
      <DialogTitle style={{ cursor: 'move', paddingBottom: 0 }} id="draggable-dialog-title">
        <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
        {getLocalizedString("selectCollaborators")}
      </DialogTitle>
      <DialogContent>
        <CommonPage
          ownGridRef={ownGridRef}
          gridTitle={getLocalizedString("collaboratorList")}
          columnDefPage={"/training/assignment/userSelection"}
          rowData={data}
          onRowDataChanged={onRowDataChanged}
          gridHeight={'70vh'}
          ignoreProcessesbyPath
        />
      </DialogContent>
      <DialogActions>
        <ButtonDialogAction onClick={handleClose} text={getLocalizedString("disagree")} />
        <ButtonDialogAction isAccept onClick={handleSubmit} text={getLocalizedString("agree")} />
      </DialogActions>
    </StyledDialog>
  );
}

export default GridSelectionDialog;